import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { RootState } from '@/store/index';
import { updateUserProfileApiCall, uploadImage } from '@/services/api'
import { setProfileStepNo } from "@/store/slices/profile/profileStepNo"
import { updateProfileFields } from "@/store/slices/profile/profileSlice"
import { idVerificationProofStatus, listOfSections } from "@/pages/profile/sections/idVerification/constants"
import { FOLDER_PATHS, FILE_NAME } from "@/constants/imageFolderPaths";

import { dataURLtoBlob, getCurrentDate } from "@/utils"

import IdVerificationStatusView from './view'

export default function IdVerificationStatus() {
    const { common } = useLocalTranslation();
    const dispatch = useDispatch()
    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);
    const profileStepNo = useSelector((state: RootState) => state.profileStepNoReducer.profileStepNo);

    const [errMsg, setErrMsg] = useState("")
    const [isSubmitBtnLoading, setIsSubmitBtnLoading] = useState(false)

    const [isUnderGraduate, setIsUnderGraduate] = useState<any>(null)
    const [qualificationNote, setQualificationNote] = useState<any>(null)
    const [lookingForNote, setLookingForNote] = useState("")
    const [underGraduateDegree, setUnderGraduateDegree] = useState<any>(null)

    const [aadharOrIdProof, setAadharOrIdProof] = useState("")
    const [legalPhoto, setLegalPhoto] = useState("")
    const [identityAcknowledged, setIdentityAcknowledged] = useState(false)
    const [marksheetOrDegreeCert, setMarksheetOrDegreeCert] = useState("")
    const [marksheetOrDegreeCertCrop, setMarksheetOrDegreeCertCrop] = useState("")
    const [fullName, setFullName] = useState("")

    const currentDateISO = getCurrentDate()

    useEffect(() => {
        updateBasicDetails()
    }, [profileDetails])


    const updateBasicDetails = () => {
        // debugger
        if (profileDetails.isUnderGraduate != null) {
            const isUnderGraduate_ = profileDetails.isUnderGraduate === true ? "Yes" : "No"
            const isUnderGraduateObj = {
                value: isUnderGraduate_,
                label: isUnderGraduate_
            }
            setIsUnderGraduate(isUnderGraduateObj)
        }
        if (profileDetails.qualificationNote != null) {
            const qualificationNoteObj = {
                value: profileDetails.qualificationNote,
                label: profileDetails.qualificationNote
            }
            setQualificationNote(qualificationNoteObj)
        }
        if (profileDetails.lookingForNote != null) {
            setLookingForNote(profileDetails.lookingForNote)
        }
        if (profileDetails.underGraduateDegree != null) {
            const underGraduateDegreeObj = {
                value: profileDetails.underGraduateDegree,
                label: profileDetails.underGraduateDegree
            }
            setUnderGraduateDegree(underGraduateDegreeObj)
        }
        if (profileDetails.aadharOrIdProof) {
            setAadharOrIdProof(profileDetails.aadharOrIdProof)
        }
        if (profileDetails.marksheetOrDegreeCert) {
            setMarksheetOrDegreeCert(profileDetails.marksheetOrDegreeCert)
        }
        if (profileDetails.passportPhoto) {
            setLegalPhoto(profileDetails.passportPhoto)
        }
        if (profileDetails.identityAcknowledged) {
            setIdentityAcknowledged(profileDetails.identityAcknowledged)
        }
        if (profileDetails.fullName) {
            setFullName(profileDetails.fullName)
        }


    }



    const handleOnCheckBoxChanged = (e: any, source: string) => {
        const val = e.target.checked
        if (source === "identityAcknowledged") {
            setIdentityAcknowledged(val)
        }
    }



    const handleInputChange = (e: any, source: string) => {
        setErrMsg('')
        const val = e.target.value
        if (source === listOfSections.isUnderGraduate) {
            const isUnderGraduateObj = {
                value: val,
                label: val
            }
            setIsUnderGraduate(isUnderGraduateObj)
        } else if (source === listOfSections.qualificationNote) {
            const qualificationNoteObj = {
                value: val,
                label: val
            }
            setQualificationNote(qualificationNoteObj)
        } else if (source === listOfSections.lookingForNote) {
            setLookingForNote(val)
        } else if (source === listOfSections.underGraduateDegree) {
            const underGraduateDegreeObj = {
                value: val,
                label: val
            }
            setUnderGraduateDegree(underGraduateDegreeObj)
        } else if (source === listOfSections.aadharOrIdProof) {
            setAadharOrIdProof(val)
        } else if (source === listOfSections.marksheetOrDegreeCert) {
            setMarksheetOrDegreeCert(val)
        } else if (source === listOfSections.legalPhoto) {
            setLegalPhoto(val)
        } else if (source === listOfSections.fullName) {
            setFullName(val)
        }
    };



    // helder function to move the cropped marksheet from marksheetDegreeCrop COM to fullName_com
    const handleSubmitV2 = (val: any, source: string) => {
        if (source === listOfSections.marksheetOrDegreeCertCrop) {
            setMarksheetOrDegreeCertCrop(val)
            dispatch(setProfileStepNo(profileStepNo + 1));
        }
    }




    const handleSubmit = async (source: string) => {
        setErrMsg('')
        setIsSubmitBtnLoading(true)
        // debugger
        if (source === listOfSections.isUnderGraduate) {
            let updateObj: any = {
                isUnderGraduate: null
            }
            if (isUnderGraduate && isUnderGraduate.value) {
                // debugger
                if (isUnderGraduate.value === "Yes") {
                    updateObj.isUnderGraduate = true
                } else {
                    updateObj.isUnderGraduate = false
                }
            }
            handleSubmit3(updateObj)
        } else if (source === listOfSections.qualificationNote) {
            let updateObj: any = {
                qualificationNote: null
            }
            if (qualificationNote && qualificationNote.value) {
                updateObj.qualificationNote = qualificationNote.value
                updateObj.verificationSubmittedAt = currentDateISO
            }
            handleSubmit3(updateObj)
        } else if (source === listOfSections.lookingForNote) {
            let updateObj: any = {
                lookingForNote: null
            }
            if (lookingForNote) {
                updateObj.lookingForNote = lookingForNote
            }
            handleSubmit3(updateObj)
        } else if (source === listOfSections.underGraduateDegree) {
            let updateObj: any = {
                underGraduateDegree: null
            }
            if (underGraduateDegree && underGraduateDegree.value) {
                const underGraduateDegreeValue = underGraduateDegree.value
                const underGraduateDegreeValue2 = underGraduateDegreeValue.replace(/\s+/g, '');
                updateObj.underGraduateDegree = underGraduateDegreeValue2
                updateObj.qualification = underGraduateDegreeValue2
                updateObj[listOfSections.qualificationStatus] = idVerificationProofStatus.inProgress
            }
            handleSubmit3(updateObj)
        } else if (source === listOfSections.aadharOrIdProof) {
            if (aadharOrIdProof) {
                handleImgUpload(listOfSections.aadharOrIdProof, aadharOrIdProof)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.marksheetOrDegreeCert) {
            if (marksheetOrDegreeCert) {
                handleImgUpload(listOfSections.marksheetOrDegreeCert, marksheetOrDegreeCert)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.legalPhoto) {
            if (legalPhoto && identityAcknowledged) {
                handleImgUpload(listOfSections.legalPhoto, legalPhoto)
            } else {
                if(!legalPhoto){
                    setErrMsg(common.statusText.pleaseGiveInput2)
                } else {
                    setErrMsg(common.statusText.pleaseGiveInput4)
                }
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.fullName) {
            if (fullName) {
                let updateObj = {
                    fullName: fullName,
                    [listOfSections.fullNameStatus]: idVerificationProofStatus.inProgress
                }
                handleSubmit3(updateObj)
            } else {
                setErrMsg(common.statusText.pleaseGiveInput)
                setIsSubmitBtnLoading(false)
            }
        } else if (source === listOfSections.allInfoPage) {
            dispatch(setProfileStepNo(profileStepNo + 1));
        }
    }


    const handleImgUpload = async (source: string, imgBase64_OR_imgUrl: any) => {
        let isImgNotChanged = false
        // debugger

        // if (profileDetails.bssForm) {
        //     let exit = false
        //     if (source === listOfSections.aadharOrIdProof
        //         && profileDetails.aadharOrIdProof
        //         && imgBase64_OR_imgUrl === profileDetails.aadharOrIdProof) {
        //         exit = true
        //     } else if (source === listOfSections.marksheetOrDegreeCert
        //         && profileDetails.marksheetOrDegreeCert
        //         && imgBase64_OR_imgUrl === profileDetails.marksheetOrDegreeCert) {
        //         exit = true
        //     }
        //     else if (source === listOfSections.legalPhoto) {
        //         if (profileDetails.passportPhoto
        //             && imgBase64_OR_imgUrl === profileDetails.passportPhoto) {
        //             isImgNotChanged = true
        //             if (identityAcknowledged === profileDetails.identityAcknowledged) {
        //                 exit = true
        //             }
        //         }
        //     }


        //     if (exit) {
        //         setIsSubmitBtnLoading(false)
        //         dispatch(setProfileStepNo(profileStepNo + 1));
        //         return
        //     }
        // }

        // debugger
        let exit2 = false
        let folderPath = ""
        let imgName = ""
        if (source === listOfSections.aadharOrIdProof) {
            folderPath = FOLDER_PATHS.IDENTITY_VERIFICATION_ID_PROOFS
            imgName = FILE_NAME.ID_PROOF
            if (source === listOfSections.aadharOrIdProof
                && profileDetails.aadharOrIdProof
                && imgBase64_OR_imgUrl === profileDetails.aadharOrIdProof) {
                isImgNotChanged = true
                if (profileDetails[listOfSections.aadharStatus] === idVerificationProofStatus.inProgress
                ) {
                    exit2 = true
                }
            }
        } else if (source === listOfSections.marksheetOrDegreeCert) {
            folderPath = FOLDER_PATHS.IDENTITY_VERIFICATION_MARKSHEETS
            imgName = FILE_NAME.MARKSHEETS
            if (profileDetails.marksheetOrDegreeCert
                && imgBase64_OR_imgUrl === profileDetails.marksheetOrDegreeCert) {
                isImgNotChanged = true
                if (profileDetails[listOfSections.marksheetStatus] === idVerificationProofStatus.inProgress
                ) {
                    exit2 = true
                }
            }
        } else if (source === listOfSections.legalPhoto) {
            folderPath = FOLDER_PATHS.IDENTITY_VERIFICATION_LEGAL_PHOTOS
            imgName = FILE_NAME.LEGAL_PHOTO
            if (profileDetails.passportPhoto
                && imgBase64_OR_imgUrl === profileDetails.passportPhoto) {
                isImgNotChanged = true
                if (identityAcknowledged === profileDetails.identityAcknowledged) {
                    if (profileDetails[listOfSections.passportPhotoStatus] === idVerificationProofStatus.inProgress
                    ) {
                        exit2 = true
                    }
                }
            }
        }


        if (exit2) {
            setIsSubmitBtnLoading(false)
            dispatch(setProfileStepNo(profileStepNo + 1));
            return
        }


        try {
            // debugger
            if (isImgNotChanged) {
                let updateObj: any = {}
                if (source === listOfSections.aadharOrIdProof) {
                    updateObj[listOfSections.aadharStatus] = idVerificationProofStatus.inProgress
                }
                if (source === listOfSections.legalPhoto) {
                    updateObj[listOfSections.passportPhotoStatus] = idVerificationProofStatus.inProgress
                }
                if (source === listOfSections.marksheetOrDegreeCert) {
                    updateObj[listOfSections.marksheetStatus] = idVerificationProofStatus.inProgress
                }
                else if (source === listOfSections.legalPhoto) {
                    updateObj["passportPhoto"] = imgBase64_OR_imgUrl
                    updateObj["verificationSubmittedAt"] = currentDateISO
                    updateObj["identityAcknowledged"] = identityAcknowledged
                    updateObj["passportPhotoStatus"] = idVerificationProofStatus.inProgress
                }
                if (Object.entries(updateObj).length > 0) {
                    handleSubmit3(updateObj)
                } else {
                    setErrMsg(common.statusText.issueInUpdating)
                    console.log("handleImgUpload", "issueInUpdating");
                }
            }
            else {
                const imgBlob = dataURLtoBlob(imgBase64_OR_imgUrl)
                if (imgBlob.status && imgBlob.blob) {
                    const response = await uploadImage(imgBlob.blob, folderPath, imgName);
                    if (response.status) {

                        let updateObj: any = {}
                        if (source === listOfSections.aadharOrIdProof) {
                            updateObj["aadharOrIdProof"] = response.data.cloudFrontUrl
                            updateObj[listOfSections.aadharStatus] = idVerificationProofStatus.inProgress
                        } else if (source === listOfSections.marksheetOrDegreeCert) {
                            updateObj["marksheetOrDegreeCert"] = response.data.cloudFrontUrl
                            updateObj[listOfSections.marksheetStatus] = idVerificationProofStatus.inProgress
                        } else if (source === listOfSections.legalPhoto) {
                            updateObj["passportPhoto"] = response.data.cloudFrontUrl
                            updateObj["verificationSubmittedAt"] = currentDateISO
                            updateObj["identityAcknowledged"] = identityAcknowledged
                            updateObj["passportPhotoStatus"] = idVerificationProofStatus.inProgress
                            updateObj[listOfSections.legalPhoto] = idVerificationProofStatus.inProgress
                        }


                        if (Object.entries(updateObj).length > 0) {
                            handleSubmit3(updateObj)
                        } else {
                            setErrMsg(common.statusText.errorUploadingImage)
                            console.log("handleImgUpload", "issue in converting base64 to blob");
                        }

                    }
                } else {
                    setErrMsg(common.statusText.errorUploadingImage)
                    console.log("handleImgUpload", "issue in converting base64 to blob");
                }
            }
        } catch (error) {
            setErrMsg(common.statusText.errorUploadingImage)
            console.log("handleImgUpload", error);
        } finally {
            setIsSubmitBtnLoading(false);
        }
    }



    const handleSubmit3 = async (updatedFields: any) => {
        const fieldsToUpdate: any = {};
        let anyFieldChanged = false;
        let anyValueEmpty = false
        // debugger
        // console.log(updatedFields)
        for (const source in updatedFields) {
            if (Object.prototype.hasOwnProperty.call(updatedFields, source)) {
                const newValue = updatedFields[source];
                const currentValue = profileDetails[source];
                const emptyCheckValidataion_ = doEmptyCheckValidataion(source)
                // debugger
                if (emptyCheckValidataion_) {
                    if (newValue === null || newValue === "") {
                        anyValueEmpty = true
                    }
                    if ((newValue !== null && newValue !== "") && newValue !== currentValue) {
                        fieldsToUpdate[source] = newValue;
                        anyFieldChanged = true;
                    }
                } else {
                    if (newValue !== currentValue) {
                        fieldsToUpdate[source] = newValue;
                        anyFieldChanged = true;
                    }
                }
            }
        }

        if (Object.keys(fieldsToUpdate).length > 0) {
            const updateUserProfileApiCallStatus = await updateUserProfileApiCall(fieldsToUpdate);

            if (updateUserProfileApiCallStatus.status) {
                dispatch(setProfileStepNo(profileStepNo + 1));
                const mergedObj = {
                    ...profileDetails, // 1. Copy all top-level properties from objB
                    ...fieldsToUpdate           // 3. Spread all properties from objA here, overwriting duplicates
                }
                dispatch(updateProfileFields(mergedObj));
            } else {
                setErrMsg(common.statusText.issueInUpdating);
            }
        } else {
            if (anyValueEmpty) {
                setErrMsg(common.statusText.pleaseGiveInput2);
            } else {
                dispatch(setProfileStepNo(profileStepNo + 1));
            }
        }

        setIsSubmitBtnLoading(false);
    };

    const doEmptyCheckValidataion = (fieldName: string) => {
        let doValidation = false
        if (fieldName === listOfSections.isUnderGraduate
            || fieldName === listOfSections.qualificationNote
            || fieldName === listOfSections.underGraduateDegree
            || fieldName === listOfSections.aadharOrIdProof
            || fieldName === listOfSections.marksheetOrDegreeCert
            || fieldName === listOfSections.fullName
            || fieldName === listOfSections.legalPhoto
            || fieldName === "identityAcknowledged") {
            doValidation = true
        }
        return doValidation
    }

    return (
        <>
            <IdVerificationStatusView
                errMsg={errMsg}
                isSubmitBtnLoading={isSubmitBtnLoading}
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                handleSubmitV2={handleSubmitV2}
                profileStepNo={profileStepNo}
                handleOnCheckBoxChanged={handleOnCheckBoxChanged}
                isUnderGraduate={isUnderGraduate}
                qualificationNote={qualificationNote}
                lookingForNote={lookingForNote}
                underGraduateDegree={underGraduateDegree}
                aadharOrIdProof={aadharOrIdProof}
                legalPhoto={legalPhoto}
                identityAcknowledged={identityAcknowledged}
                marksheetOrDegreeCert={marksheetOrDegreeCert}
                marksheetOrDegreeCertCrop={marksheetOrDegreeCertCrop}
                fullName={fullName}
            />
        </>
    );
}
